import React from 'react';

const FloatingActionButton = ({ onClick, className = '' }) => {
  return (
    <button
      onClick={onClick}
      className={`
        fixed bottom-6 right-6 z-50
        w-14 h-14 rounded-full
        bg-brand hover:bg-brand-hover
        text-white dark:text-gray-900
        shadow-lg hover:shadow-xl
        transition-all duration-200
        flex items-center justify-center
        lg:hidden
        ${className}
      `}
      aria-label="Create"
    >
      <svg
        className="w-6 h-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        strokeWidth={2.5}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 4v16m8-8H4"
        />
      </svg>
    </button>
  );
};

export default FloatingActionButton; 